/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Option } from "@nordcloud/gnui/dist/components/dropdown/types";
export const currencyList = [
  {
    symbol: "€",
    name: "Euro",
    code: "EUR",
  },
  {
    symbol: "$",
    name: "US Dollar",
    code: "USD",
  },
  {
    symbol: "zł",
    name: "Polish Zloty",
    code: "PLN",
  },
  {
    symbol: "£",
    name: "British Pound Sterling",
    code: "GBP",
  },
  {
    symbol: "Nkr",
    name: "Norwegian Krone",
    code: "NOK",
  },
  {
    symbol: "CHF",
    name: "Swiss Franc",
    code: "CHF",
  },
  {
    symbol: "Skr",
    name: "Swedish Krona",
    code: "SEK",
  },
  {
    symbol: "Dkr",
    name: "Danish Krone",
    code: "DKK",
  },
];

export const currencyOptions: Option[] = currencyList.map((currency) => ({
  value: currency.code,
  label: `${currency.name} ${currency.symbol}`,
}));
